module.exports = "# <center> PokerMan Account Deletion</center>\n\n\n  - Account Name\n  - Creation date of the account\n  - Location that you registered the account from (City, Country)\n  - The email address that bind to your account\n  - Email title: PokerMan Account Deletion\n\nPlease write email to <support@pokerman.io> with the information above to request account deletion in PokerMan App.\n\nwe may need to ask you some extra questions to verify ownership through email. We take these steps to ensure the security of all accounts.\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/md/accountDeletion.md
// module id = pyZt
// module chunks = 1